export default __webpack_public_path__ + "static/media/hungry.bc13c624.png";